import { concatClasses } from "../../../helpers/concatClasses/index.js";
import { getGroupDropdownClasses } from "../FormGroup/utils.js";
const getFontSize = (size) => {
  switch (size) {
    case "smaller":
      return "dsf-text-xxs";
    case "small":
      return "dsf-text-xs";
    case "medium":
    default:
      return "dsf-text-s";
  }
};
const getHeight = (size) => {
  switch (size) {
    case "smaller":
      return "h-24";
    case "small":
      return "h-32";
    case "medium":
    default:
      return "h-40";
  }
};
const getPadding = (size) => {
  switch (size) {
    case "smaller":
      return "pr-4 pl-8";
    case "small":
      return "px-8";
    case "medium":
    default:
      return "px-12";
  }
};
const getSelectClasses = (cmp) => {
  const { dsf_open, dsf_options, disabled, dsf_success, dsf_error, dsf_size } = cmp;
  const classes = [
    "font-sans",
    "flex-auto",
    "flex",
    "items-center",
    "outline-none",
    "overflow-hidden",
    "w-auto"
  ];
  const hasValue = dsf_options.length > 0;
  classes.push(...getGroupDropdownClasses(hasValue, dsf_open, cmp._group_position));
  classes.push(getFontSize(dsf_size));
  classes.push(getHeight(dsf_size));
  classes.push(getPadding(dsf_size));
  classes.push(disabled ? "cursor-not-allowed" : "cursor-pointer");
  if (disabled) {
    classes.push("bg-neutral-50");
  } else {
    classes.push("bg-neutral-0 hover:bg-secondary-50");
  }
  if (dsf_error) {
    classes.push("border-error-300");
  } else if (dsf_success) {
    classes.push("border-success-300");
  } else {
    classes.push("border-neutral-100");
  }
  if (!disabled) {
    classes.push("focus:border-secondary-300");
    classes.push("focus-visible:shadow-focus-secondary-md");
  }
  return concatClasses(classes);
};
const getTextLabelClasses = ({ dsf_options, disabled }) => {
  const classes = ["flex-auto", "flex", "items-center", "gap-8", "truncate"];
  if (!dsf_options.length || disabled) {
    classes.push("text-neutral-400");
  }
  return concatClasses(classes);
};
const getArrowIconClasses = ({ dsf_open, disabled }) => {
  const classes = ["h-16", "w-16", "flex-shrink-0", "transition-all", "ml-4"];
  if (dsf_open) {
    classes.push("rotate-180");
  }
  if (disabled) {
    classes.push("text-neutral-400");
  }
  return concatClasses(classes);
};
const getHiddenLabelClasses = ({ dsf_success, dsf_error, disabled }) => {
  const classes = [
    "dsf-text-xxs flex h-20 min-w-20 p-4 shrink-0 items-center justify-center rounded-full text-neutral-0"
  ];
  if (disabled) {
    classes.push("bg-neutral-200");
  } else if (dsf_error) {
    classes.push("bg-error-300");
  } else if (dsf_success) {
    classes.push("bg-success-300");
  } else {
    classes.push("bg-secondary-300");
  }
  return concatClasses(classes);
};
const getIconMargin = (size) => {
  switch (size) {
    case "smaller":
      return "mr-4";
    case "small":
      return "mr-8";
    case "medium":
    default:
      return "mr-12 ml-4";
  }
};
const getIconSize = (size) => {
  switch (size) {
    case "smaller":
      return "h-12 w-12";
    case "small":
      return "h-14 w-14";
    case "medium":
    default:
      return "h-16 w-16";
  }
};
const getIconClasses = ({ dsf_size }) => {
  const classes = ["shrink-0"];
  classes.push(getIconMargin(dsf_size));
  classes.push(getIconSize(dsf_size));
  return concatClasses(classes);
};
const getXIconMargin = (size) => {
  switch (size) {
    case "smaller":
      return "ml-4";
    case "small":
      return "ml-8";
    case "medium":
    default:
      return "ml-12";
  }
};
const getXIconClasses = ({ dsf_size, disabled }) => {
  const classes = ["h-16 w-16 shrink-0 rounded-sm"];
  classes.push(getXIconMargin(dsf_size));
  classes.push(disabled ? "" : "hover:bg-neutral-100");
  return concatClasses(classes);
};
export {
  getArrowIconClasses,
  getHiddenLabelClasses,
  getIconClasses,
  getSelectClasses,
  getTextLabelClasses,
  getXIconClasses
};
